module.exports = __webpack_public_path__ + "img/coin_gfd.093a47d6.png";